import(/* webpackMode: "eager" */ "/home/ubuntu/apps/trade_fomo_web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/apps/trade_fomo_web/src/components/GAListener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/ubuntu/apps/trade_fomo_web/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/apps/trade_fomo_web/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/apps/trade_fomo_web/src/styles/globals.css");
